import { useAppSelector } from "@/store/hooks";
import { useAccessRight, useTranslate } from "@/hooks";
import { selectDatasetsList } from "@/store/authSlice";
import { selectCurrentUserInfo } from "@/store/userSlice";
import { DATASET } from "@/constants/accessRights";
import { DatasetBlockRoot, DatasetText, DatasetTextBold } from "./DatasetBlock.styles";

const DatasetBlock = () => {
	const datasetsList = useAppSelector(selectDatasetsList);
	const currentUserInfo = useAppSelector(selectCurrentUserInfo);

	const isAccess = useAccessRight(); // hook для проверки прав доступа
	const translate = useTranslate();

	const isVisible = currentUserInfo.dataset !== "0";

	if (!isAccess(DATASET.LIST)) return <></>;

	return (
		<DatasetBlockRoot
			sx={{
				maxHeight: isVisible ? "20px" : 0, // только высота
				overflow: "hidden",
				transition: "all 0.3s linear",
				borderBottom: isVisible ? "1px solid rgba(0, 0, 0, 0.12)" : "none",
				margin: isVisible ? "4px 0 4px !important" : "0",
				padding: isVisible ? "0 0 4px !important" : "0",
			}}
		>
			<DatasetText component="span" sx={{ opacity: isVisible ? 1 : 0 }}>
				<DatasetTextBold component="span">{translate("title_dataset")}: </DatasetTextBold>
				{currentUserInfo.dataset
					? datasetsList.dictionary[currentUserInfo.dataset] ?? `${currentUserInfo.dataset} (${translate("title_notFound")})`
					: translate("title_notFound")}
			</DatasetText>
		</DatasetBlockRoot>
	);
};

export default DatasetBlock;
